export default __webpack_public_path__ + "static/media/11-74.7fd13c74.png";